export default "<canvas id=\"sellerRevenueChart\"></canvas>\r\n"